import { AttributesMixin, define, Linked, type } from "@type-r/models";
import { asDate, CompactInput, div, Input } from "lqx-react";
import { FilterModel } from "./base-filter-model";

import * as React from 'react';
import { useModel } from "@type-r/react";
import { styled } from "@material-ui/core/styles";

export interface DateRangeFilter extends AttributesMixin<typeof DateRangeFilter> { }
@define
export class DateRangeFilter extends FilterModel {
    static attributes = {
        ...FilterModel.attributes,
        from: type(Date).null,
        to: type(Date).null
    }

    delete() {
        this.from = undefined;
        this.to = undefined;
    }

    asLabel() {
        return asDate(this.from) + ' - ' + asDate((this.to));
    }
}

export const SelectDateRange = ({ model, $from, $to }: {
    model?: DateRangeFilter
    $from?: Linked<Date>
    $to?: Linked<Date>
}) => {

    const $start = model ? model.$.from : $from;
    const $end = model ? model.$.to : $to;

    return (

        <>
            <DateInputContainer>
                <DateInput $value={ $start }
                    date
                    placeholder="From"
                    selectsStart
                    endDate={ $end.value }
                />
            </DateInputContainer>
            <DateInputContainer>
                <DateInput $value={ $end }
                    date
                    placeholder="To"
                    selectsEnd
                    startDate={ $start.value }
                    endDate={ $end.value }
                    minDate={ $start.value }
                />
            </DateInputContainer>
        </>
    )
}


export const CompactSelectDateRange = ({ fromLabel, $from, toLabel, $to }: {
    fromLabel: React.ReactNode
    $from: Linked<Date>
    toLabel: React.ReactNode
    $to: Linked<Date>
}) =>
    <>
        <CompactInput label={ fromLabel } $value={ $from }
            date
            placeholder="From"
            selectsStart
            endDate={ $to.value }
        />

        <CompactInput label={ toLabel } $value={ $to }
            date
            placeholder="To"
            selectsEnd
            startDate={ $from.value }
            endDate={ $to.value }
            minDate={ $from.value }
        />
    </>

export const EnterRange = ({ onEnter }) => {
    const state = useModel(DateRangeFilter);

    React.useEffect(() => {
        const range = { from: state.from, to: undefined };
        if (state.to)
            range.to = state.to.setHours(23, 59, 59, 999);
        onEnter(range);
    }, [ state[ '_changeToken' ] ]);

    return (
        <SelectDateRange model={ state } />
    )
}

const DateInputContainer = div({
    marginRight: '10px'
});

const DateInput = styled(Input)({
    margin: "5px 10px 5px 0px",
    border: "1px solid #c4c4c4",
    borderRadius: "4px"
});
